import {AppController} from "@ok/web/modules/block/AppController";
import {RbAdBannerEmergedFooterStore} from "./RbAdBannerEmergedFooterStore";

export class RbAdBannerEmergedFooterController extends AppController<RbAdBannerEmergedFooterStore> {
}
